/**
 * Created by Ning Jiang on 2023-11-15.
 */
import {WinPresentationController} from "../WinPresentationController";
import {DCRoadReelsView} from "../../reels/DCRoadReelsView";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {DCRoadReelsController} from "../../reels/DCRoadReelsController";
import {gsap} from "gsap";
import {DevilsCrossRoadSound} from "../../sound/DevilsCrossRoadSound";
import {BelowStakeWinRestriction} from "../../server/BelowStakeWinRestriction";

export class InitialMultipliersController extends WinPresentationController {

    private _multiItemDelays:number [] = [0.2, 0.2, 0.2, 0.2];

    private _allSymbolNames:string[];

    constructor() {
        super("InitialMultipliersController", true);
    }

    protected hasWin():boolean {
        this._allSymbolNames = [];
        DevilsCrossRoad.model.gameData.betWayWins.forEach(betWayWin => {
            if(!this._allSymbolNames.includes(betWayWin.symbol)) {
                this._allSymbolNames.push(betWayWin.symbol);
            }
        });

        if(DevilsCrossRoad.model.data.forbiddenSymbols) {
            DevilsCrossRoad.model.data.forbiddenSymbols.forEach(sym => {
                if (!this._allSymbolNames.includes(sym)) {
                    this._allSymbolNames.push(sym);
                }
            });
        }
        return this._allSymbolNames.length > 0;
    }

    protected async createWinAnimation():Promise<any> {
        const tl = gsap.timeline();
        const allMultiTl = gsap.timeline();
        let multiDelay = 0;
        DCRoadReelsView.STOP_ORDER_QUAD_COUNTER.forEach(p => {
            const sym = DevilsCrossRoad.reels.getSymbol(p[0], p[1]);
            if(sym && !sym.isWin && !sym.isForbidden && this._allSymbolNames.includes(sym.symbolName)) {
                sym.isMulti = true;
                const multiDevWay = DCRoadReelsController.DEV_WAYS_MAP[sym.reelId][sym.symId];
                const multiSymbolTl = gsap.timeline();
                const multiTl = gsap.timeline();
                // if(!this._belowStakeWinRestriction) {
                //     multiSymbolTl.add(sym.playWinAnimation(this._winLevel));
                // }
                DevilsCrossRoad.multipliers.addWinMultiplierToTimeline(multiDevWay, sym.getGlobalPosition(), multiSymbolTl, multiTl)
                multiSymbolTl.add(sym.playDisintegrateAnimation());
                tl.add(multiSymbolTl, 0);
                allMultiTl.add([
                    multiTl,
                    DevilsCrossRoad.devil.playWinAnimation(multiDevWay)
                ], multiDelay);
                multiDelay += this._multiItemDelays[DevilsCrossRoad.model.currentWinRatioConfig?.winLevel!];
            }
        });
        if(tl.totalDuration() > 0 && !BelowStakeWinRestriction.isWinBelowPlayedBetValue()) {
            tl.add(() => {
                DevilsCrossRoadSound.soundPlayer.playTrack({name : DevilsCrossRoadSound.SYMBOL_WIN_MULTI});
            }, 0);
        }
        if(allMultiTl.totalDuration() > 0) {
            tl.add(allMultiTl);
        }

        if(tl.totalDuration() > 0) {
            return Promise.resolve(tl);
        }
        return Promise.resolve();
    }

    protected skip() {
        // super.skip();
    }
}